// @flow
import React from 'react'
import content from 'pp-react-l10n'
import { connect } from 'transfer/utils/p2p-connect'
import Overpanel from 'react-components/overpanel'
import ThreeDSecureOverpanel from '../ThreeDSecureOverpanel'
import { toggle3DSecureOverpanel } from 'transfer/actions/overpanels'
import { errorThreeDS, handleThreeDS } from 'transfer/actions/send'

let i18n = content('transfer/page/preview')

const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args))

type Props = Overpanel & {
  handleFailure: () => void,
  handleSuccess: () => void,
  onSuccess?: () => void,
  onFailure?: () => void,
}
export function ThreeDSOverpanel({
  show,
  handleClose,
  handleFailure,
  handleSuccess,
  onSuccess = () => {},
  onFailure = () => {},
}: Props) {
  return (
    <Overpanel show={show} handleClose={handleClose}>
      <ThreeDSecureOverpanel
        handle3DSSuccess={callAll(handleSuccess, onSuccess)}
        handle3DSFailure={callAll(handleFailure, onFailure)}
        show={show}
      />
    </Overpanel>
  )
}

export default connect(
  ({ overpanels }) => ({
    show: overpanels.threeDSecure,
  }),
  dispatch => ({
    handleClose: () =>
      dispatch(toggle3DSecureOverpanel({ show: false, close: true })),
    handleSuccess: () => {
      dispatch(toggle3DSecureOverpanel({ show: false }))
      dispatch(handleThreeDS())
    },
    handleFailure: () => {
      dispatch(toggle3DSecureOverpanel({ show: false }))
      dispatch(errorThreeDS({ message: i18n('error.threeDS') }))
    },
  })
)(ThreeDSOverpanel)
